(ns hai.library.sources.ms-file-picker
  ""
  (:require
   [hai.library.sources.filepicker :as filepicker]
   [hai.ui.components.button :as button]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [<s >e defevent defevent-fx defsub]]
   [lambdaisland.deja-fu :as fu]
   [lambdaisland.ornament :as o]
   [lambdaisland.uri :as uri]
   [reagent.core :as reagent]))

(defn link-account-url [& {:keys [type login-hint]}]
  (str (uri/assoc-query
        (assoc (uri/uri js/window.location)
               :path "/login/microsoft" :query nil :fragment nil)
        :scope "openid email User.Read Files.Read Sites.Read.All offline_access"
        ;; Bypass account selection, we are upgrading/refreshing a known account
        :login_hint login-hint
        ;; Make sure to show the consent screen, otherwise we may get a cached
        ;; authorization without all the requested scopes
        :prompt "consent"
        :response_type "link_account"
        :redirect-path (str (uri/assoc-query
                             js/window.location.pathname
                             :source_tab (name type))))))

(o/defstyled account-button :button
  :border-none :flex :flex-row :items-center :gap-4
  [:.icon :bg-gray-200 :rounded-full :flex :items-center :justify-center
   {:width "40px" :height "40px"}]
  ([attrs icon caption]
   [:<> attrs
    [:div.icon icon]
    caption]))

(defn- needs-reauth?
  "We need to make sure the authorization we have for the user can actually be
  used to get OneDrive/Sharepoint files. That means it needs to have the right
  scopes, and it needs to either still be valid, or have the offline_access
  scope so we can refresh the token. Note that offline_access is not actually
  reflected in the scope list, but we can check if there's a refresh token. We
  make sure we still have at least ten minutes on the token, otherwise we ask
  for a reauth."
  [{:oauth.authorization/keys [scopes expires-at has-refresh-token?] :as conn}]
  (not
   (and (some #{"Files.Read" "Sites.Read"} scopes)
        (or has-refresh-token?
            (< (fu/epoch-ms (fu/add-interval (fu/local-date-time) {:minutes 10}))
               (fu/epoch-ms expires-at))))))

(o/defstyled account-picker :div
  :flex :flex-col :gap-4
  [:.logo-line :flex :text-2xl]
  [:h3 :text-black]
  ([conns {:keys [type confirm-button-text on-confirm]}]
   (reagent/with-let [conn-id (reagent/atom nil)]
     (if @conn-id
       [filepicker/filepicker {:conn-id @conn-id
                               :url (case type
                                      :sharepoint
                                      "humble:ms-sharepoint-v1:/"
                                      :onedrive
                                      "humble:ms-drive-v1:/")
                               :on-confirm on-confirm
                               :confirm-button-text confirm-button-text
                               :on-nav-out #(reset! conn-id nil)}]
       [:<>
        [:div.logo-line [icons/microsoft {:width 30}] "Microsoft"]
        [:h3 "Pick an account"]
        (into
         [:<>]
         (for [{:connection/keys [uuid description] :as conn} conns]
           (if (needs-reauth? conn)
             [account-button {:on-click #(set! js/window.location.href (link-account-url {:type type
                                                                                          :login-hint (:oauth.authorization/identity conn)}))}
              [icons/outlined-person] [:div description [:br] [:small "Needs re-authentication"]]]
             [account-button {:on-click #(reset! conn-id uuid)}
              [icons/outlined-person] description])))
        [account-button {:on-click #(set! js/window.location.href (link-account-url {:type type}))} [icons/plus] "Use another account"]]))))

(o/defstyled first-account-button :div
  :flex :justify-center :mt-11
  ([type]
   [:a {:class (str button/icon-button)
        :href (link-account-url {:type type})}
    [icons/microsoft {:width 20}] "Connect Microsoft Account"]))

(o/defstyled picker :div
  ([opts]
   (let [conns (filter (comp #{:microsoft} :connection/type)
                       (:connections @(<s :auth/identity)))]
     [:<>
      (if (seq conns)
        [account-picker conns opts]
        [first-account-button (:type opts)])])))
